/* eslint-disable no-script-url */
import React from "react";
import Constant from "../../_constants/user.constants";
import { authenticationService } from "../../_services/authentication.service";
import "../Login/Login.css";

class Login extends React.Component {
  constructor(props) {
    super(props);
    if (authenticationService.currentUserValue) {
      this.props.history.push("/admin-home");
    }
    this.state = {
      username: "",
      password: "",
      submitted: false,
      formType: Constant.FORM_LOGIN,
      remember: false,
      message: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    const { username, password, formType } = this.state;
    let formData = null;

    if (formType === Constant.FORM_LOGIN) {
      if (username && password) {
        const model = {
          emailId: username,
          password: password,
        };

        formData = JSON.stringify(model);
        authenticationService.login(formData).then((response) => {
          if (!response) {
            const { from } = this.props.location.state || {
              from: { pathname: "/admin-home" },
            };
            this.props.history.push(from);
          } else {
            this.setState({ message: response });
          }
        });
      }
    } else {
      if (username) {
        const model = {
          emailId: username,
        };
        formData = JSON.stringify(model);
        authenticationService.forgotPassword(formData).then((response) => {
          this.setState({ message: response });
        });
      }
    }
  }
  render() {
    const { username, password, submitted, formType, remember, message } =
      this.state;
    return (
      <div className="login-page wrapper">
        <nav className="appHeaderAdmin">
          <div className="container">
            <a className="navbar-brand" href="/admin-login">
              <img
                aria-hidden="true"
                width="42"
                height="42"
                src="images/walmart-logo.png"
                alt="Walmart Logo"
              />
              <span className="logo-title">Vacuum Accessory Finder</span>
            </a>
          </div>
        </nav>
        <div className="login-box margin-top">
          <div className="card ">
            <div className="card-body login-card-body">
              <React.Fragment>
                <p className="login-box-msg"></p>{" "}
                <h5>
                  {formType === Constant.FORM_LOGIN
                    ? Constant.MEMBER_LOGIN
                    : Constant.MEMBER_CHANGE_PASSWORD}
                </h5>
                {message ? (
                  <div className="alert alert-success">
                    <small>{message}</small>
                  </div>
                ) : null}
              </React.Fragment>
              <form name="form" onSubmit={this.handleSubmit}>
                <div
                  className={
                    "input-group mb-3" +
                    (submitted && !username ? " invalid" : "")
                  }
                >
                  <input
                    type="email"
                    name="username"
                    value={username}
                    className="form-control"
                    placeholder="Email"
                    onChange={this.handleChange}
                  />
                  <div className="input-group-append">
                    <div className="input-group-text input-group-text-extn">
                      <span className="fa fa-envelope"></span>
                    </div>
                  </div>
                </div>
                <div
                  className={
                    "input-group mb-3" +
                    (submitted && !password ? " invalid" : "")
                  }
                  style={{
                    display: formType === Constant.FORM_LOGIN ? "" : "none",
                  }}
                >
                  <input
                    type="password"
                    name="password"
                    value={password}
                    maxLength="8"
                    className="form-control"
                    placeholder="Password"
                    onChange={this.handleChange}
                  />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fa fa-lock"></span>
                    </div>
                  </div>
                </div>
                <div
                  className="row"
                  style={{
                    display: formType === Constant.FORM_LOGIN ? "none" : "none",
                  }}
                >
                  <div className="col-12">
                    <div className="icheck-primary small">
                      <input
                        type="checkbox"
                        id="remember"
                        name="remember"
                        checked={remember}
                        onChange={(e) => this.setState({ remember: !remember })}
                      />
                      <label htmlFor="remember">Remember Me</label>
                    </div>
                  </div>
                </div>
                <div className="row row-margin-top">
                  <div className="col-12">
                    <button className="btn btn-block btn-login">
                      {formType === Constant.FORM_LOGIN
                        ? Constant.SIGN_IN
                        : Constant.REQUEST_NEW_PASSWORD}
                    </button>
                  </div>
                </div>
              </form>
              <p className="mb-1 mb-1-margin">
                <a
                  href="Javascript:void(0);"
                  onClick={(e) =>
                    this.setState({
                      username: "",
                      password: "",
                      message: "",
                      submitted: false,
                      remember: false,
                      emailValid: false,
                      passwordValid: false,
                      formType:
                        formType === Constant.FORM_LOGIN
                          ? Constant.FORM_CHANAGE_PASSWORD
                          : Constant.FORM_LOGIN,
                    })
                  }
                >
                  {formType === Constant.FORM_LOGIN
                    ? Constant.I_FORGOT_MY_PASSWORD
                    : Constant.LOGIN}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Login;
